import React, { Component }  from 'react';
import { connect } from 'react-redux';
import { ResultDialog } from '../..';
import './CoreLayout.scss';
import { hideFailedDialog, hideSucceedDialog } from '../../../redux/modules/dialog'

const mapStateToProps = (state) => ({
  showSucceed: state.dialog.showSucceed,
  showFailed: state.dialog.showFailed,
})

const mapActionCreators = {
  hideSucceedDialog,
  hideFailedDialog
}

class DialogContainer extends Component {
  static defaultProps = {
  }

  state = {
  }



  render() {
    const { showSucceed, showFailed } = this.props;
    return <>
     {showSucceed && <ResultDialog 
       succeed={true}
       title='申请成功'
       text='将会优先获取您提交代币的信息，一般2分钟内更新完成。若超过10分钟仍未更新，请直接联系我们！'
       onDismiss={this.props.hideSucceedDialog}
     />}
     {showFailed && <ResultDialog 
       succeed={false}
       title='提交失败'
       text='可能是链上网络等原因，导致该代币信息更新失败。若多次提交均失败，请直接联系我们！'
       onDismiss={this.props.hideFailedDialog}
     />}
    </>
  }
}

export default connect(mapStateToProps, mapActionCreators)(DialogContainer);

